import React, {
  ForwardedRef,
  MouseEventHandler,
  ReactNode,
  ReactNodeArray,
} from "react";
import styled from "styled-components/macro";

type BoxProps = {
  id?: string;
  style?: React.CSSProperties;
  className?: string;
  border?: string;
  variant?:
    | "primary"
    | "shaded"
    | "error"
    | "warning"
    | "success"
    | "info"
    | "transparent";
  size?: "xsmall" | "small" | "medium" | "large";
  onClick?: MouseEventHandler<HTMLDivElement>;
  children?: ReactNode | ReactNodeArray;
};

const StyledRoot = styled.div<BoxProps>`
  padding: ${(props) =>
    props.size === "xsmall"
      ? "0.5rem"
      : props.size === "small"
      ? "1rem"
      : props.size === "medium"
      ? "1.25rem"
      : "1.5rem"};
  border: ${(props) => (props.border ? `${props.border}` : "1px")} solid
    ${(props) =>
      props.variant === "error"
        ? "var(--error-color)"
        : props.variant === "warning"
        ? "var(--alert-color-background)"
        : props.variant === "success"
        ? "var(--G100)"
        : props.variant === "info"
        ? "var(--light-blue)"
        : props.variant === "shaded"
        ? "transparent"
        : props.variant === "transparent"
        ? "transparent"
        : "var(--border-gray-light)"};
  border-radius: var(--rounded-corner-large);
  background-color: ${(props) =>
    props.variant === "shaded"
      ? "var(--N200)"
      : props.variant === "error"
      ? "var(--background-error-color)"
      : props.variant === "warning"
      ? "var(--alert-color-background)"
      : props.variant === "success"
      ? "var(--background-green)"
      : props.variant === "info"
      ? "var(--light-blue)"
      : props.variant === "transparent"
      ? "transparent"
      : "var(--white)"};
  box-shadow: ${(props) =>
    props.variant === "transparent" ? "" : "var(--drop-shadow)"};
  animation: slide-down 0.3s ease-out;
`;

export const Box = React.forwardRef(
  (
    {
      id,
      className,
      children,
      variant = "primary",
      size = "medium",
      onClick,
      style,
      border,
    }: BoxProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <StyledRoot
        id={id}
        style={style}
        ref={ref}
        className={className}
        variant={variant}
        size={size}
        onClick={onClick}
        border={border}
      >
        {children}
      </StyledRoot>
    );
  },
);

Box.displayName = "Box";
